import React from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import { METRICS } from "./usePerformance";
import { translateFr as tfr } from "@/i18n";

/* Internal CSV export: KPI + timeline values only. No athlete names, no private content. */
function buildCsv(data) {
  const lines = [[tfr("Indicateur"), tfr("Valeur"), tfr("Précédent"), tfr("Variation")].join(";")];
  (data.kpis || []).forEach((k) => {
    lines.push([k.key, k.display || (k.value ?? ""), k.previousDisplay || (k.previous ?? ""), k.delta ?? ""].join(";"));
  });
  lines.push("");
  const metricLabel = METRICS.find((m) => m.id === data.timeline?.metric)?.label || data.timeline?.metric;
  lines.push([`Date (${metricLabel})`, tfr("Période actuelle"), tfr("Période précédente")].join(";"));
  (data.timeline?.current || []).forEach((p, i) => {
    lines.push([p.date, p.value, data.timeline.previous?.[i]?.value ?? ""].join(";"));
  });
  return lines.join("\n");
}

export default function ExportMenu({ data }) {
  const exportCsv = () => {
    if (!data) return;
    const csv = buildCsv(data);
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `athlynx-performance-${data.period?.from}-${data.period?.to}.csv`;
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success(tfr("Export CSV téléchargé"));
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2 h-10" data-testid="perf-export-btn">
          <Download className="h-4 w-4" /> {tfr("Exporter")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="perf-export-menu">
        <DropdownMenuItem onClick={exportCsv} data-testid="perf-export-csv">{tfr("Exporter en CSV (KPI + évolution)")}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
